




















import { Component, Vue } from "vue-property-decorator";
import gql from "graphql-tag";

import TabBar from "@/basics/tab/TabBar.vue";
import TabItem from "@/basics/tab/TabItem.vue";

@Component({
  components: {
    TabBar,
    TabItem
  }
})
export default class TabFrame extends Vue {
  building = null;
  groups = [];

  get loading(): boolean {
    return this.$apollo.loading;
  }
}
